// src/api.js
import axios from "axios";

// live

// Old:
// const baseURL = "http://18.60.7.141/api";
// const baseURL = "http://16.112.145.235/api";
// const baseURL = "https://compoundx.duckdns.org/api";

// New:
// const baseURL = "http://40.192.28.228/api";
// const baseURL = "http://16.112.218.114/api";
const baseURL = "https://apexalgo.duckdns.org/api";

// local
// const baseURL = "http://localhost:4000/api";

// ✅ Create Axios instance
const api = axios.create({ baseURL });

// -----------------------------------------------------
// ✅ 1. Request Interceptor → Always attach token
// -----------------------------------------------------
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// -----------------------------------------------------
// ✅ 2. Response Interceptor → Auto logout on 403
// -----------------------------------------------------
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      console.warn("⚠️ Token expired — Auto logout triggered");

      // Clear all local data
      localStorage.clear();

      // Notify App.js to logout user
      window.dispatchEvent(new Event("forceLogout"));
    }

    return Promise.reject(error);
  },
);

export default api;

// ------------------------------------------------------------------

// // src/api.js
// import axios from "axios";

// // live
// const baseURL = "http://18.60.7.141/api";

// // local
// // const baseURL = "http://localhost:4000/api";

// // ✅ Create Axios instance without token initially
// const api = axios.create({ baseURL });

// // ✅ Add a request interceptor to always attach token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// export default api;
